import React from 'react'
import ClassNames from 'classnames';
import Template from './checkbox.rt';
import Styles from './checkbox.less';

module.exports = React.createClass({
  propTypes: {
    className: React.PropTypes.string,
    onChange: React.PropTypes.func,
    disabled: React.PropTypes.bool,
    label: React.PropTypes.string,
    checked: React.PropTypes.bool,
    tabIndex: React.PropTypes.number,
    autoFocus: React.PropTypes.bool,
    isNotValid: React.PropTypes.bool
  },
  getInitialState: function () {
    return {
      isChecked: this.props.checked
    };
  },
  componentWillReceiveProps: function(nextProps) {
    this.setState({
      isChecked: nextProps.checked
    });
  },
  handleChange(event){
    var isChecked = event.target.checked;
    this.props.onChange && this.props.onChange(event, isChecked);
    this.setState({isChecked: isChecked});
  },
  getClass() {
    return ClassNames(
      Styles.checkbox,
      {
        disabled: this.props.disabled,
        notValid: this.props.isNotValid
      },
      this.props.className);
  },
  getLabelClass(){
    return ClassNames(
      Styles.label,
      {
      checked: this.state.isChecked,
      disabled: this.props.disabled
    });
  },
  render: Template
});



/** WEBPACK FOOTER **
 ** ./src/form-controls/checkboxes/checkbox/index.js
 **/